export default __webpack_public_path__ + "assets/images/5613dade85b3c075bab1703edda4ada6.jpg";